var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1497_1582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3297 7.43012L13.3297 7.43013C13.6647 7.89627 13.8442 8.44351 13.8442 9.01641C13.8442 9.58928 13.6647 10.1365 13.3298 10.6028C13.2188 10.7571 13.0908 10.9027 12.9463 11.0376L12.9463 11.0376C12.6729 11.293 12.6728 11.7107 12.9463 11.966C13.0816 12.0923 13.2574 12.1541 13.4313 12.1541C13.6049 12.1541 13.7808 12.0922 13.916 11.966C14.7583 11.1799 15.2242 10.1321 15.2242 9.01641C15.2242 7.90068 14.7583 6.85288 13.916 6.06666L13.916 6.06666C13.6474 5.81596 13.2151 5.81599 12.9463 6.06679C12.6728 6.32207 12.6728 6.73998 12.9463 6.99525C13.0908 7.1301 13.2188 7.27568 13.3297 7.43012Z",
    fill: "#05275D",
    stroke: "#05275D",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0489 1.35539L10.0489 1.35538C9.30494 1.03656 8.45506 1.1473 7.83194 1.64716L3.61951 5.0257H0.565011C0.192158 5.0257 -0.125 5.30975 -0.125 5.67804V12.3554C-0.125 12.7235 0.192136 13.0077 0.565011 13.0077H3.61951L7.83193 16.3863C7.83194 16.3863 7.83194 16.3863 7.83195 16.3863C8.21947 16.6972 8.69497 16.8576 9.17819 16.8576C9.47164 16.8576 9.76781 16.7985 10.0489 16.6781L10.0489 16.678C10.7939 16.3587 11.2637 15.6805 11.2637 14.9052V3.12825C11.2637 2.35284 10.7939 1.67473 10.0489 1.35539ZM8.72497 15.3913L8.72494 15.3913L4.56284 12.0533V5.98014L8.72494 2.64198C8.93918 2.47015 9.21962 2.43258 9.47883 2.54372L9.47885 2.54373C9.73733 2.6545 9.88364 2.87301 9.88364 3.12825V14.9052C9.88364 15.1604 9.73733 15.3789 9.47885 15.4897C9.21948 15.6009 8.9392 15.5633 8.72497 15.3913ZM1.25502 6.33039H3.18282V11.7031H1.25502V6.33039Z",
    fill: "#05275D",
    stroke: "#05275D",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1497_1582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic-on.6255b1bd01cd36b7cc22d79d8b41c091.svg";
export { ForwardRef as ReactComponent };